/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../../types/enums.js";

/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | rr_donnelley_domestic_economy_parcel | Domestic Economy Parcel|
 * | rr_donnelley_domestic_priority_parcel | Domestic Priority Parcel |
 * | rr_donnelley_domestic_parcel_bpm | Domestic Parcel BPM|
 * | rr_donnelley_priority_domestic_priority_parcel_bpm | Domestic Priority Parcel BPM|
 * | rr_donnelley_priority_parcel_delcon | International Priority Parcel DelCon|
 * | rr_donnelley_priority_parcel_nondelcon | International Priority Parcel NonDelcon|
 * | rr_donnelley_economy_parcel | Economy Parcel Service |
 * | rr_donnelley_ipa | International Priority Airmail (IPA)|
 * | rr_donnelley_courier | International Courier|
 * | rr_donnelley_isal | International Surface Air Lift (ISAL)|
 * | rr_donnelley_epacket | e-Packet|
 * | rr_donnelley_pmi | Priority Mail International|
 * | rr_donnelley_emi | Express Mail International|
 */
export const ServiceLevelePostGlobalEnum = {
  RrDonnelleyDomesticEconomyParcel: "rr_donnelley_domestic_economy_parcel",
  RrDonnelleyDomesticPriorityParcel: "rr_donnelley_domestic_priority_parcel",
  RrDonnelleyDomesticParcelBpm: "rr_donnelley_domestic_parcel_bpm",
  RrDonnelleyPriorityDomesticPriorityParcelBpm:
    "rr_donnelley_priority_domestic_priority_parcel_bpm",
  RrDonnelleyPriorityParcelDelcon: "rr_donnelley_priority_parcel_delcon",
  RrDonnelleyPriorityParcelNondelcon: "rr_donnelley_priority_parcel_nondelcon",
  RrDonnelleyEconomyParcel: "rr_donnelley_economy_parcel",
  RrDonnelleyIpa: "rr_donnelley_ipa",
  RrDonnelleyCourier: "rr_donnelley_courier",
  RrDonnelleyIsal: "rr_donnelley_isal",
  RrDonnelleyEpacket: "rr_donnelley_epacket",
  RrDonnelleyPmi: "rr_donnelley_pmi",
  RrDonnelleyEmi: "rr_donnelley_emi",
} as const;
/**
 * |Token | Service name|
 *
 * @remarks
 * |:---|:---|
 * | rr_donnelley_domestic_economy_parcel | Domestic Economy Parcel|
 * | rr_donnelley_domestic_priority_parcel | Domestic Priority Parcel |
 * | rr_donnelley_domestic_parcel_bpm | Domestic Parcel BPM|
 * | rr_donnelley_priority_domestic_priority_parcel_bpm | Domestic Priority Parcel BPM|
 * | rr_donnelley_priority_parcel_delcon | International Priority Parcel DelCon|
 * | rr_donnelley_priority_parcel_nondelcon | International Priority Parcel NonDelcon|
 * | rr_donnelley_economy_parcel | Economy Parcel Service |
 * | rr_donnelley_ipa | International Priority Airmail (IPA)|
 * | rr_donnelley_courier | International Courier|
 * | rr_donnelley_isal | International Surface Air Lift (ISAL)|
 * | rr_donnelley_epacket | e-Packet|
 * | rr_donnelley_pmi | Priority Mail International|
 * | rr_donnelley_emi | Express Mail International|
 */
export type ServiceLevelePostGlobalEnum = ClosedEnum<
  typeof ServiceLevelePostGlobalEnum
>;

/** @internal */
export const ServiceLevelePostGlobalEnum$inboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelePostGlobalEnum
> = z.nativeEnum(ServiceLevelePostGlobalEnum);

/** @internal */
export const ServiceLevelePostGlobalEnum$outboundSchema: z.ZodNativeEnum<
  typeof ServiceLevelePostGlobalEnum
> = ServiceLevelePostGlobalEnum$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ServiceLevelePostGlobalEnum$ {
  /** @deprecated use `ServiceLevelePostGlobalEnum$inboundSchema` instead. */
  export const inboundSchema = ServiceLevelePostGlobalEnum$inboundSchema;
  /** @deprecated use `ServiceLevelePostGlobalEnum$outboundSchema` instead. */
  export const outboundSchema = ServiceLevelePostGlobalEnum$outboundSchema;
}
